import type {Schemas} from 'api/dto.generated';

export const sortMarcdata = (data: Schemas.Marcdata[]): Schemas.Marcdata[] => {
  return data.sort((a, b) => {
    if (!a.tag) {
      return -1;
    }

    if (!b.tag) {
      return 1;
    }

    return a.tag.localeCompare(b.tag);
  });
};
